import { render, staticRenderFns } from "./evaluation_main_mobile.vue?vue&type=template&id=83d852e2&scoped=true"
import script from "./evaluation_main_mobile.vue?vue&type=script&lang=js"
export * from "./evaluation_main_mobile.vue?vue&type=script&lang=js"
import style0 from "./evaluation_main_mobile.vue?vue&type=style&index=0&id=83d852e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d852e2",
  null
  
)

export default component.exports